import React from "react";
import Container from "../../elements/Container";
import LastProduct1 from "../../../assets/img/Burgers/LastProducts-1.jpg";
import LastProduct2 from "../../../assets/img/Burgers/LastProducts-2.jpg";
import LastProduct3 from "../../../assets/img/Burgers/LastProducts-3.jpg";

export default function LastProducts() {
   return (
      <Container className="my-10 md:my-[78px] px-12">
         <div className="w-full flex flex-col gap-y-4 sm:grid sm:grid-cols-2 gap-x-9 sm:gap-y-8 grid-rows-2 font-secondary uppercase text-white">
            <div className="bg-yellow-300 row-span-2 rounded-lg relative">
               <div className="p-5">
                  {/* Photo */}
                  <img
                     src={LastProduct1}
                     alt="Présentation des plus beaux burgers"
                     className="absolute top-0 left-0 rounded-md h-full w-full object-cover"
                  />
                  {/* Texte */}
                  <div className="relative z-10">
                     <span className="block font-semibold text-2xl tracking-tighter">
                        The Killer{" "}
                     </span>
                     <span className="text-3xl md:text-4xl font-semibold tracking-tighter">
                        Burger le plus< br/> populaire
                     </span>
                  </div>
               </div>
            </div>

            <div className="bg-yellow-300 row-span-1 rounded-lg relative">
               <div className="p-5">
                  {/* Photo */}
                  <img
                     src={LastProduct2}
                     alt="Présentation des plus beaux burgers"
                     className="absolute top-0 left-0 rounded-md h-full w-full object-cover"
                  />
                  {/* Texte */}
                  <div className="relative z-10">
                     <span className="block font-semibold text-2xl tracking-tighter">
                        The twins
                     </span>
                     <span className="text-3xl md:text-4xl font-semibold tracking-tighter">
                        Pour le goût <br />
                        Pour le plaisir
                     </span>
                  </div>
               </div>
            </div>

            <div className="bg-yellow-300  row-span-1 rounded-lg relative">
               <div className="p-5">
                  {/* Photo */}
                  <img
                     src={LastProduct3}
                     alt="Présentation des plus beaux burgers"
                     className="absolute top-0 left-0 rounded-md h-full w-full object-cover"
                  />
                  {/* Texte */}
                  <div className="relative z-10">
                     <span className="block font-semibold text-2xl tracking-tighter">
                        The Red-Hot
                     </span>
                     <span className="text-3xl md:text-4xl font-semibold tracking-tighter">
                        Frais &< br/> pimenté
                     </span>
                  </div>
               </div>
            </div>
         </div>
      </Container>
   );
}
